"use client";

import React from "react";
import { MapPin } from "lucide-react";
import { Link } from "@/components/common/Link";
const locations = [{
  name: "Homestead",
  path: "/home-inspection-in-homestead-fl/"
}, {
  name: "Kendall",
  path: "/kendall-home-inspector/"
}, {
  name: "Miami",
  path: "/miami-home-inspector/"
}, {
  name: "Miami-Dade County",
  path: "/miami-dade-county-home-inspector/"
}, {
  name: "Broward County",
  path: "/broward-county-home-inspector/"
}, {
  name: "Florida Keys",
  path: "/florida-keys-home-inspector/"
}];
export default function ServiceAreas() {
  return <section id="service-areas" className="dark bg-background text-foreground py-24 px-4 lg:px-8 overflow-hidden">
      <div className="max-w-3xl mx-auto flex flex-col items-center text-center">
        <div className="mb-10 max-w-2xl">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold uppercase tracking-tight mb-4">
            Areas We <span className="text-primary">Serve</span>
          </h2>
          <p className="text-lg text-muted-foreground leading-relaxed">
            Trusted Inspections serves South Florida, including Homestead, Kendall, Miami, Miami-Dade County, Broward County, and the Florida Keys.
          </p>
        </div>

        <div className="w-full max-w-2xl">
          <ul className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-y-4 gap-x-6">
            {locations.map((location, i) => <li data-index={i} key={location.name}>
                <Link to={location.path} className="group flex items-center gap-3 text-muted-foreground hover:text-primary transition-colors duration-200 py-2 px-3 rounded-md hover:bg-muted/10 text-left">
                  <MapPin className="w-4 h-4 opacity-50 group-hover:opacity-100 transition-opacity shrink-0" />
                  <span className="font-medium">{location.name}</span>
                </Link>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}